import { clsx } from 'clsx'

import { SelectListbox, type SelectListboxProps } from 'base-ui'

import styles from './ProductSearchRefinementSortingSelectListbox.module.css'

export const ProductSearchRefinementSortingSelectListbox = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>({
  className,
  ...rest
}: SelectListboxProps<OptionValue, Multiple>): JSX.Element => (
  <SelectListbox
    className={clsx(
      styles['product-search-refinement-sorting-select-listbox'],
      className,
    )}
    {...rest}
  />
)
